const CONTENT_SERVICE = {
  HEADER_CODE_ID: 'naumai-primary',
}

export default CONTENT_SERVICE
